module.exports = __webpack_public_path__ + "static/media/20201121_215949_098_IMG_0985.8944d571.jpg";